module.exports = __webpack_public_path__ + "static/media/jeshurunAvatar.95824c0f.jpg";